// Updated PartialRefundModal.js
import React from "react";
import "./PartialRefundModal.css";
import {
  Dialog,
  Grid,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Autocomplete,
  TableContainer,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { IoMdClose } from "react-icons/io";
// Import utils
import {
  getRefundTotalForItem,
  getAddonTotalPrice,
} from "../../refundCalculations"; // Adjust path

const PartialRefundModal = ({
  openPartialRefundModal,
  row,
  handleCloseRefundModals,
  itemImg,
  calculatedTotalFoodItemPrice,
  selectedRowToRefund,
  handleCheckboxSelection,
  RefundValidationError,
  setRefundReason,
  refundReason,
  addOnToRefund,
  setAddOnToRefund,
  selectedRefundProcessingType,
  setSelectedRefundProcessingType,
  emailAddressToSendRefundPaymentForm = "",
  setEmailAddressToSendRefundPaymentForm,
  closeIcon,
  selectedPartialRefundItems,
  alteredQuantity,
  handleQuantityChange,
  handleAddonCheckbox,
  refundProcessingType,
  PartialRefundRequest,
  refundProcessingTypeValidationError,
  emailValidationError,
}) => {
  const getDisplayAmountsForItem = (item, RefundQty) => {
    const isSelected = selectedPartialRefundItems.some(
      (s) => s.orderItemId === item.orderItemId
    );
    console.log("RefundQtyadawdawsdaw", RefundQty, item);
    const currRefundQty = isSelected
      ? alteredQuantity.find((aq) => aq.orderItemId === item.orderItemId)
          ?.quantity || item.qty
      : item.qty;
    const currSelAddons = isSelected
      ? addOnToRefund.filter((a) => a.orderItemId === item.orderItemId)
      : (item.addons || []).filter((ad) => ad.refundStatus !== "Refunded");
    return getRefundTotalForItem(
      item,
      RefundQty,
      currSelAddons,
      selectedRowToRefund
    );
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"xl"}
      open={openPartialRefundModal}
      onClose={handleCloseRefundModals}
    >
      <Grid
        container
        className="d-flex space-between align-items-center"
        style={{ backgroundColor: "rgb(86, 89, 91)" }}
      >
        <Grid item xs={6}>
          <DialogTitle>
            <div className="d-flex" style={{ gap: "8px" }}>
              <div>
                <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
              </div>
              <span style={{ color: "#ffffffff" }}>Partial Refund</span>
            </div>
          </DialogTitle>
        </Grid>
        <Grid item xs={6}>
          <DialogActions>
            <Button onClick={handleCloseRefundModals}>
              <IoMdClose
                style={{ width: "1.2rem", fontSize: "2.2rem", color: "white" }}
              />
            </Button>
          </DialogActions>
        </Grid>
      </Grid>

      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <div>
          <h6>Order Id: # {selectedRowToRefund?.id?.slice(-6)}</h6>
          <p className="text-muted y-1">RefundTypeId: Partial Refund</p>
          <h3>Refund Amount: ￡{calculatedTotalFoodItemPrice}</h3>
          <hr />
          <div style={{ padding: "8px" }}>
            <TableContainer component={Paper} elevation={0}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "200px", textAlign: "center" }}>
                      Selected Items
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <strong>Item Name</strong>
                    </TableCell>
                    <TableCell style={{ textAlign: "center", width: "160px" }}>
                      <strong>Item Tips</strong>
                    </TableCell>
                    <TableCell style={{ textAlign: "center", width: "160px" }}>
                      <strong>Item Service Ch.</strong>
                    </TableCell>
                    <TableCell style={{ textAlign: "center", width: "160px" }}>
                      <strong>Item Service Ch. Vat</strong>
                    </TableCell>
                    <TableCell
                      style={{ width: "200px", textAlign: "center" }}
                      align="center"
                    >
                      <strong>FoodItem Quantity</strong>
                    </TableCell>
                    <TableCell style={{ width: "200px", textAlign: "center" }}>
                      <strong>Addon Details</strong>
                    </TableCell>
                    <TableCell style={{ width: "150px", textAlign: "center" }}>
                      <strong>AddOn Tips</strong>
                    </TableCell>
                    <TableCell style={{ width: "150px", textAlign: "center" }}>
                      <strong>AddOn Service Charge</strong>
                    </TableCell>
                    <TableCell style={{ width: "150px", textAlign: "center" }}>
                      <strong>AddOn Service Charge Vat</strong>
                    </TableCell>
                    <TableCell style={{ width: "150px", textAlign: "center" }}>
                      <strong>Total Amount</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedRowToRefund?.items
                    ?.filter((item) => item.qty > 0)
                    ?.map((item, index) => {
                      // const amounts = getDisplayAmountsForItem(item);
                      const isSelected = selectedPartialRefundItems.some(
                        (s) => s.orderItemId === item.orderItemId
                      );
                      const currRefundQty = isSelected
                        ? alteredQuantity.find(
                            (aq) => aq.orderItemId === item.orderItemId
                          )?.quantity || item.qty
                        : item.qty;
                      const amounts = getDisplayAmountsForItem(
                        item,
                        currRefundQty
                      );
                      const currSelAddonsIds = isSelected
                        ? addOnToRefund
                            .filter((a) => a.orderItemId === item.orderItemId)
                            .map((a) => a.id)
                        : (item.addons || [])
                            .filter((ad) => ad.refundStatus !== "Refunded")
                            .map((ad) => ad.id);
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            <Checkbox
                              checked={isSelected}
                              onChange={() => handleCheckboxSelection(item)}
                            />
                          </TableCell>
                          <TableCell style={{ textWrap: "nowrap" }}>
                            <Typography
                              style={{ fontWeight: "bold", textWrap: "nowrap" }}
                            >
                              {item.orderItemName} - ￡{amounts.itemPrice}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            ￡{amounts.itemTips}
                          </TableCell>
                          <TableCell align="center">
                            ￡{amounts.itemSC}
                          </TableCell>
                          <TableCell align="center">
                            ￡{amounts.itemSCVat}
                          </TableCell>
                          <TableCell align="center">
                            {item.qty > 1 ? (
                              <div
                                className="d-flex align-items-center gap-3"
                                style={{ minWidth: "150px" }}
                              >
                                <div
                                  className="d-flex align-items-center justify-content-center OHL-plusButton"
                                  onClick={() =>
                                    handleQuantityChange("-", item)
                                  }
                                >
                                  <h3 style={{ margin: "0px" }}>-</h3>
                                </div>
                                <TextField
                                  type="number"
                                  size="small"
                                  value={currRefundQty}
                                  inputProps={{
                                    min: 1,
                                    max: item.qty,
                                    step: 1,
                                  }}
                                  disabled={!isSelected}
                                />
                                <div
                                  className="d-flex align-items-center justify-content-center OHL-plusButton"
                                  onClick={() =>
                                    handleQuantityChange("+", item)
                                  }
                                >
                                  <h3 style={{ margin: "0px" }}>+</h3>
                                </div>
                              </div>
                            ) : (
                              <Typography className="ml-1">
                                {item.qty}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {item?.addons?.length === 0 && (
                              <Typography className="text-muted">
                                No Add-ons
                              </Typography>
                            )}
                            {item?.addons?.map((addon, aIdx) => {
                              const isRefunded =
                                addon.refundStatus === "Refunded";
                              const isSelectedAddon = currSelAddonsIds.includes(
                                addon.id
                              );
                              const showCheckbox =
                                item.qty > 1 && !isRefunded && isSelected;
                              const isFullQty =
                                !isSelected || currRefundQty === item.qty;
                              return (
                                <div key={aIdx} className="addonRow">
                                  {showCheckbox && !isFullQty && (
                                    <Checkbox
                                      checked={isSelectedAddon}
                                      onChange={() =>
                                        handleAddonCheckbox(
                                          addon,
                                          item.orderItemId
                                        )
                                      }
                                    />
                                  )}
                                  {showCheckbox && isFullQty && (
                                    <Checkbox checked disabled />
                                  )}
                                  {isRefunded && <Checkbox disabled checked />}
                                  <div className="addonColumn">
                                    {isRefunded ? (
                                      <Typography className="addonRefunded">
                                        <span style={{ marginRight: 6 }}>
                                          {item.addons.length > 1
                                            ? `${aIdx + 1}.`
                                            : ""}
                                        </span>
                                        <div>
                                          <span className="addonBold">
                                            {addon.addOnName}
                                          </span>{" "}
                                          Is Already Refunded
                                        </div>
                                      </Typography>
                                    ) : (
                                      <Typography>
                                        <span style={{ marginRight: 6 }}>
                                          {item.addons.length > 1
                                            ? `${aIdx + 1}.`
                                            : ""}
                                        </span>
                                        <span className="addonBold">
                                          {addon.addOnName} - ￡
                                          {addon.totalPrice}
                                        </span>
                                        {addon?.options?.length > 0 && (
                                          <div className="optionBlock">
                                            {addon.options.map(
                                              (option, oIdx) => (
                                                <div
                                                  key={oIdx}
                                                  className="optionRow"
                                                >
                                                  <span>
                                                    {option.optionName} - ￡
                                                    {option.totalPrice}
                                                  </span>
                                                  {option?.subOptions?.length >
                                                    0 && (
                                                    <div className="subOptionBlock">
                                                      {option.subOptions.map(
                                                        (subOption, subIdx) => (
                                                          <div key={subIdx}>
                                                            <span>
                                                              {
                                                                subOption.subOptionName
                                                              }{" "}
                                                              - ￡
                                                              {
                                                                subOption.totalPrice
                                                              }
                                                            </span>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                      </Typography>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </TableCell>
                          <TableCell
                            sx={{ textAlign: "center", textWrap: "nowrap" }}
                          >
                            <Typography>￡{amounts.addonTips}</Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography>￡{amounts.addonSC}</Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography>￡{amounts.addonSCVat}</Typography>
                          </TableCell>
                          <TableCell sx={{ textWrap: "nowrap" }}>
                            <Typography>￡{amounts.total}</Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {row?.items?.filter((item) => item.qty > 0).length === 0 && (
                    <h5 style={{ color: "gray", minWidth: "300px" }}>
                      All items are refunded.
                    </h5>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {selectedPartialRefundItems.length === 0 && RefundValidationError && (
            <span style={{ color: "red", marginLeft: "15px" }}>
              * Select Items to refund.
            </span>
          )}
          <Grid
            container
            className="d-flex align-items-center justify-content-center"
          >
            <Grid item xs={3}>
              <Typography style={{ paddingTop: "1rem" }}>
                Select Refund Transaction Type
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Autocomplete
                multiple={false}
                id="refund-item-autocomplete"
                options={refundProcessingType}
                getOptionLabel={(type) => type.label}
                value={selectedRefundProcessingType}
                onChange={(event, newValue) =>
                  setSelectedRefundProcessingType(newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select way to refund"
                    placeholder="Choose ways"
                    variant="outlined"
                    sx={{ mt: 2 }}
                  />
                )}
              />
              {refundProcessingTypeValidationError && (
                <span style={{ color: "red" }}>
                  * Please provide a way to refund.
                </span>
              )}
            </Grid>
          </Grid>
          {selectedRefundProcessingType?.id === 1 && (
            <Grid
              container
              style={{ paddingTop: "0.5rem" }}
              className="d-flex align-items-center justify-content-center"
            >
              <Grid item xs={3}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Email Address
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  margin="normal"
                  label="Enter Email Address"
                  variant="outlined"
                  value={emailAddressToSendRefundPaymentForm}
                  onChange={(e) =>
                    setEmailAddressToSendRefundPaymentForm(e.target.value)
                  }
                  required
                  type="email"
                />
                {emailValidationError && (
                  <span style={{ color: "red" }}>
                    * Please provide an email to refund.
                  </span>
                )}
              </Grid>
            </Grid>
          )}
          <Grid
            container
            className="d-flex align-items-center justify-content-center"
          >
            <Grid item xs={3}>
              <Typography style={{ paddingTop: "1rem" }}>Reason</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                margin="normal"
                label="Refund Reason Description"
                variant="outlined"
                value={refundReason}
                onChange={(e) => setRefundReason(e.target.value)}
                required
              />
              {RefundValidationError && refundReason === "" && (
                <span style={{ color: "red" }}>
                  * Please provide a reason to refund.
                </span>
              )}
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={PartialRefundRequest}
          color="primary"
          variant="contained"
          disabled={
            RefundValidationError ||
            row?.items?.filter((item) => item.qty > 0).length === 0
          }
        >
          Partial Refund
        </Button>
        <Button onClick={handleCloseRefundModals} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartialRefundModal;
